import { createSelector } from '@ngrx/store';
import { RolesState } from '../types';
import { FeatureKey } from '../constants';

export const getRolesSelector = createSelector(
  (state: any) => state[FeatureKey],
  (roles: RolesState) => roles.rolesList,
)!;

export const getPermissionsSelector = createSelector(
  (state: any) => state[FeatureKey],
  (roles: RolesState) => roles?.permissionList,
)!;

export const getCurrentEditUserRoleSelector = createSelector(
  (state: any) => state[FeatureKey],
  (roles: RolesState) => roles.currentEditUserRole,
);
